
/***** Hold the promise card out of the layout until its position is settled *****
  The card is placed by script: it is moved into whichever product-page column has
  the shorter content and sized to the gap. That decision cannot be made until the
  gallery, Bold's options, Judge.me and Clyde have finished changing the columns, so
  the card landed in one column off the first measurement and then jumped to the
  other. On the Durston wedging table it went from col-md-7 (top 935) to col-md-5
  (top 559) about 1.3s in, for a card-attributed CLS of 0.127 (median of 8).

  So it starts out of the flow entirely and is revealed once the columns stop moving.
  Revealing it drops it into space that was already empty, which costs no shift:
  card-attributed CLS on that product is 0 across 8 runs.

  This line runs at parse time, NOT inside ready(), because this file is render
  blocking in the head - the class therefore exists before the body paints and the
  card never appears in the wrong place even for a frame. If this file is ever
  deferred or moved below the fold, that guarantee is gone and the card will flash
  in its initial position first.

  No script, no class, and the card simply behaves as it did before.
***/
(function () {
  var root = document.documentElement;
  root.classList.add('sc-promise-deciding');
  // Backstop: if the placement script never runs - an error earlier in the file, a
  // page without the card - reveal anyway rather than losing the card altogether.
  window.setTimeout(function () { root.classList.remove('sc-promise-deciding'); }, 5000);
})();

/*** CSS FOR CART PAGE **/
var ur = window.location.href;
if (ur.includes("/cart")) {
   jQuery(document).ready(function () {
        var timmerX = setInterval(function () {
            if (jQuery("*").hasClass("soulceramic-checkout-top") == false && jQuery('.empty-cart-message').length==0) {
       	jQuery('#content').prepend('<a class="soulceramic-checkout-top">Check Out</a>');
                    jQuery(document).on("click",".soulceramic-checkout-top",function(e) {
      		jQuery('.cart_btn button[type="submit"]').eq(0).click();
          	});
            } else {
                clearInterval(timmerX);
            }
        }, 100);
    });
}
/*** CSS FOR PRODUCT PAGE **/
var ur = window.location.href;

/** COOKIE FOR CART REDIRECT **/

var ur = window.location.href;
/***** BUY NOW ***/
 function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays  * 15 * 1000);
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    console.log(expires);
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}
if (ur.includes("/cart")) {
    function checkCookie() {
              var counter = getCookie("CookieVarBuyNow");
              if (counter == "1") {
                  setCookie("CookieVarBuyNow", "", 1);
                  console.log("counter2");
    jQuery('html').hide();
                  jQuery(location).attr("href", "/checkout");
              } else {
                  jQuery("html").addClass('cart-show');
              }
          }
      jQuery(document).ready(function () {
              checkCookie();
          });
      } else {
          setCookie("CookieVarBuyNow", "", 1);
      }


/*** Slider Code *
var ur = window.location.href;
if (ur.includes("/products")) {
jQuery( document ).ready(function() {
 
     

      
console.log('product item '+ window.productItem);



      var timerSlider2 = setInterval(function () {
             if( jQuery('#slidecarthq .cart-count').hasClass('sc-hideSlider')==false){ 
               window.productItem = jQuery('.cart-count').text();

        jQuery('.cart-count').addClass('sc-hideSlider');

             }
          
        }, 100);


  
  
           var timerSlider = setInterval(function () {
             if( window.productItem < jQuery('.cart-count').text() && jQuery('body').hasClass('sc-test')==false){
          
            
              clearInterval(timerSlider);
             setTimeout(function(){
                console.log(window.productItem < jQuery('.cart-count').text())
               
              window.location.href = '/cart';
             
             }, 500)
             }
        }, 500);



});

  

}
*/

/***** Shared: scroll an element to just below the sticky header, then re-aim once
       the scroll settles (the header switches to position:fixed on scroll, which
       removes it from the flow and shifts the page under the target). ***/
// How far down the viewport is still covered by the sticky header. Desktop nav bar or
// the mobile header, whichever is displayed; once it has gone fixed its viewport bottom
// is the exact amount to clear.
function scHeaderOffset() {
  var candidates = document.querySelectorAll('#header .header_bot, .wsmobileheader');
  var h = 0;
  Array.prototype.forEach.call(candidates, function(el) {
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none') { return; }
    var r = el.getBoundingClientRect();
    var v = cs.position === 'fixed' ? r.bottom : r.height;
    if (v > h) { h = v; }
  });
  return (h || 65) + 15;
}

function scScrollToElement(el) {
  function wantedTop() {
    return el.getBoundingClientRect().top + window.pageYOffset - scHeaderOffset();
  }
  // The header goes position:fixed as soon as scrolling starts (shifting the page up
  // under the target) and then animates its height for 0.3s. Rather than correcting
  // with a visible snap at the end, re-aim the smooth scroll while it is in flight
  // whenever the target moves by more than a few px, so it arrives in one motion.
  var target = wantedTop();
  var started = performance.now();
  var done = false;
  function finish() {
    if (done) { return; }
    done = true;
    window.removeEventListener('scrollend', finish);
    var want = wantedTop();
    if (Math.abs(window.pageYOffset - want) > 2) { window.scrollTo({ top: want, behavior: 'auto' }); }
  }
  function track() {
    if (done) { return; }
    var want = wantedTop();
    if (Math.abs(want - target) > 6) {
      target = want;
      window.scrollTo({ top: target, behavior: 'smooth' });
    }
    if (performance.now() - started < 2500) { window.requestAnimationFrame(track); } else { finish(); }
  }
  window.addEventListener('scrollend', finish);
  window.scrollTo({ top: target, behavior: 'smooth' });
  window.requestAnimationFrame(track);
}

/***** Sticky bottom bars: "Configure & Add to Cart" on product pages, "Check Out" on the cart ***/
// Shared plumbing: show/hide the bar from a scroll check, keep the Zendesk launcher and
// Shopify's preview toolbar clear of it, and wire the button.
function scInitStickyBar(bar, shouldShow, onClick) {
  // Keep the Zendesk launcher clear of the bar: lift it clear of wherever the bar
  // actually sits. Takes no argument and reads the bar itself, so it can be called
  // from anything that moves or resizes the bar, not only from a show/hide.
  var lastLift = null;
  function setLauncherOffset() {
    var lift = bar.hidden ? 0 : (parseInt(bar.style.bottom, 10) || 0) + bar.offsetHeight + 10;
    // Idempotent: updateBar calls this on every scroll frame, and telling Zendesk to
    // re-apply the offset it already has would be a settings round-trip per frame.
    if (lift === lastLift) { return; }
    lastLift = lift;
    var viaApi = false;
    if (typeof window.zE === 'function') {
      try {
        window.zE('webWidget', 'updateSettings', { webWidget: { offset: {
          vertical: lift + 'px', mobile: { vertical: lift + 'px' } } } });
        viaApi = true;
      } catch (e) {}
    }
    // The CSS fallback carries the same measured lift rather than a fixed guess, and
    // comes off again as soon as the API takes over - the widget can load after the
    // bar's first show (it is deferred to first interaction), so an early show may
    // have fallen back to the class and this call is the one that can place it
    // properly. Leaving the class on alongside a working API would lift the launcher
    // twice.
    document.documentElement.style.setProperty('--sc-launcher-lift', lift + 'px');
    document.body.classList.toggle('sc-sticky-cta-visible', !bar.hidden && !viaApi);
  }

  // A plain scroll check rather than IntersectionObserver: IO only fires when the target
  // crosses the viewport edge, so a jump that skips straight past it (anchor scroll,
  // fast flick on mobile) would never show the bar.
  var ticking = false;
  function updateBar() {
    ticking = false;
    var show = shouldShow();
    if (bar.hidden !== !show) { bar.hidden = !show; }
    // Unconditionally, not only when the visibility flipped: a resize can change the
    // bar's height while it stays on screen. setLauncherOffset no-ops when the number
    // has not moved, so this is cheap.
    setLauncherOffset();
  }
  function onScroll() {
    if (ticking) { return; }
    ticking = true;
    window.requestAnimationFrame(updateBar);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  // The page keeps growing after this runs: Bold rewrites the cart rows and Clyde
  // injects a protection-plan iframe per item, which pushes the target hundreds of
  // pixels down. Neither fires scroll or resize, so without this the bar decides
  // "target is visible" against the short initial page and stays hidden until the
  // shopper happens to scroll. The bar is position:fixed, so re-running this cannot
  // feed back into the observed size.
  if (window.ResizeObserver) {
    new ResizeObserver(onScroll).observe(document.body);
  }
  updateBar();

  // Shopify's theme-preview toolbar also docks to the bottom; sit above it when present.
  // (The preview iframe is a tall transparent overlay with the visible strip at its
  // bottom, so its own height is useless; the strip itself is ~60px.)
  function liftAbovePreviewBar() {
    var previewBar = document.getElementById('PBarNextFrame') || document.getElementById('preview-bar-iframe');
    var shown = previewBar && previewBar.getBoundingClientRect().height > 0;
    var want = shown ? '60px' : '';
    if (bar.style.bottom === want) { return; }
    bar.style.bottom = want;
    // The launcher's lift was measured against the old offset, so re-aim it at the new
    // one. Without this the bar moves up by 60px and the launcher does not follow,
    // which is the chat bubble sitting on the right end of the bar on every dev-theme
    // preview - and the preview bar turns up after the cart bar's first show, so it is
    // the cart page that shows it.
    setLauncherOffset();
  }
  liftAbovePreviewBar();
  window.addEventListener('resize', liftAbovePreviewBar);
  setTimeout(liftAbovePreviewBar, 2000);

  // By class, not the first button in the bar: the cart bar also carries a small
  // notes button, which is wired separately by its own caller.
  bar.querySelector('.sc-sticky-cta__btn').addEventListener('click', onClick);
  return { update: updateBar };
}

// Product page: show once the add-to-cart form has scrolled off the top of the viewport.
// Bold Options hides the theme's #addToCart and injects a clone with the same id, so
// watch the whole form instead of the button.
$(document).ready(function() {
  var bar = document.getElementById('sc-sticky-cta');
  var form = document.getElementById('addToCartForm');
  if (!bar || !form) { return; }
  scInitStickyBar(bar, function() {
    return form.getBoundingClientRect().bottom < 0;
  }, function() {
    // Side-by-side layout (gallery beside the buy box): go back to the very top so the
    // title, gallery and options all show as on a fresh load. Stacked layout: land on the form.
    var sideBySide = window.matchMedia('(min-width: 768px)').matches;
    if (sideBySide) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      scScrollToElement(form);
    }
  });
});

// Cart page: show whenever the real Check Out button is off screen in either direction
// (below the fold on load with a tall cart, or scrolled past to the reviews/footer).
// The bar's button submits the cart form the same way the real one does.
$(document).ready(function() {
  var bar = document.getElementById('sc-cart-sticky');
  var checkout = document.querySelector('.cart_btn button[name="checkout"]');
  if (!bar || !checkout) { return; }
  var sticky = scInitStickyBar(bar, function() {
    // "Off screen" = less than half the button visible, so a sliver peeking over the
    // bottom edge still gets the bar.
    var r = checkout.getBoundingClientRect();
    var half = r.height / 2;
    return r.bottom < half || r.top > window.innerHeight - half;
  }, function() {
    checkout.click();
  });

  /* The bar's small notes button: bring the whole Order Summary card into view - which
     is Check Out, the wallet buttons AND the notes box - and then put the caret in the
     notes box. Scrolling to the textarea alone would leave the checkout controls off
     screen, which is the opposite of what someone reaching for the notes from a sticky
     bar wants to see. */
  var noteBtn = bar.querySelector('[data-sc-cart-note]');
  if (noteBtn) {
    // Not getElementById: the header's mini-cart drawer (snippets/menu-cart.liquid)
    // renders a second textarea with this same id earlier in the document, and that one
    // is the hidden one - focusing it does nothing at all. Take the summary's own.
    // Looked up again on every click because an ajax cart update can rebuild the card.
    var findNote = function() {
      var box = document.querySelector('.cart_btn.sc-cart-summary');
      return { summary: box, note: box && box.querySelector('#cartSpecialInstructions') };
    };
    // Liquid already omits the button when settings.cart_notes is off; this also covers
    // the textarea being removed by an app.
    if (!findNote().note) {
      noteBtn.hidden = true;
    } else {
      noteBtn.addEventListener('click', function() {
        var found = findNote();
        var summary = found.summary, note = found.note;
        if (!note) { return; }
        // From 1200px up the summary rides in a position:sticky column, so while it is
        // pinned its rect does not move with the page and scScrollToElement's re-aim
        // loop settles on the scroll position where the two agree rather than putting
        // the card exactly under the header. Measured on a tall cart at 1400x900 it
        // lands with the card at top 99px and the whole of it, Check Out and the
        // wallet buttons included, inside the viewport - which is all this needs.
        scScrollToElement(summary);
        // preventScroll: the helper owns the scrolling here. Without it the browser
        // first jumps the textarea to the viewport edge, which is the notes-only view
        // we are deliberately not giving.
        try { note.focus({ preventScroll: true }); } catch (e) { note.focus(); }
      });
    }
  }

  // Keep the bar's subtotal in step with the cart's (Bold/ajax updates rewrite it in place).
  var amount = bar.querySelector('.sc-cart-sticky__amount');
  var source = document.querySelector('.total_row .total-price');
  // The "(2 items)" beside the subtotal is rendered by Liquid and ajaxify-shop.js only
  // rewrites the money figures, so after a quantity change it stated the count the page
  // loaded with. Re-add it from the rows on screen, which is what it is meant to say.
  var count = document.querySelector('.sc-cart-summary__count');
  function updateCount() {
    if (!count) { return; }
    var boxes = document.querySelectorAll('#your-shopping-cart #content .cart_tbl .con_row .txtbox');
    var total = 0;
    for (var i = 0; i < boxes.length; i++) {
      total += parseInt(boxes[i].value, 10) || 0;
    }
    if (total > 0) {
      count.textContent = '(' + total + ' ' + (total === 1 ? 'item' : 'items') + ')';
    }
  }
  if (amount && source && window.MutationObserver) {
    new MutationObserver(function() {
      amount.textContent = source.textContent.trim();
      updateCount();
      sticky.update();
    }).observe(source, { childList: true, subtree: true, characterData: true });
  }
});

/***** Cart page: show the Clyde protection-plan widget as a full-width band *****
  Clyde injects its widget into the product title cell, where it only gets what the
  Price, Quantity and Total columns leave over - about 300px at desktop, and narrow
  enough at 991px and on phones that Clyde falls back to its two-line variant and
  grows from 87px to 136px tall. The other four columns are at their minimums, so
  there is no width to give it in place.

  So the row gets a band underneath it and the widget is positioned into that band.
  Note what this does NOT do: it never moves the widget in the DOM. Reparenting an
  element containing an iframe reloads that iframe, and Clyde's iframe reloading means
  its handshake with the parent script runs again - which is not ours to be clever
  with when the thing on the other side of it adds a paid contract to the cart. The
  widget stays exactly where Clyde put it; only its box moves.

  All this needs from JS is the band's height, which comes from the inline height
  Clyde sets on the wrapper, and a spacer element to reserve it. If none of it runs,
  the widget stays inline in the title cell, where the stylesheet's rules still lay
  it out.
***/
$(document).ready(function() {
  var row = document.querySelector('#your-shopping-cart #content .cart_tbl .con_row');
  if (!row) { return; }

  function spacerFor(ul) {
    var next = ul.nextElementSibling;
    return (next && next.className.indexOf('sc-cart-clyde') > -1) ? next : null;
  }

  function sync() {
    var kids = row.children;
    for (var i = 0; i < kids.length; i++) {
      var ul = kids[i];
      if (ul.tagName !== 'UL') { continue; }
      var widget = ul.querySelector('.clyde-cart-div');
      var spacer = spacerFor(ul);
      if (!widget) {
        // No plan on this item: hand the divider back to the row, lose the spacer.
        if (spacer) { spacer.parentNode.removeChild(spacer); }
        ul.className = ul.className.replace(/ ?sc-has-clyde/, '');
        continue;
      }
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'sc-cart-clyde';
        ul.parentNode.insertBefore(spacer, ul.nextSibling);
      }
      // Clyde sets the wrapper's height in an inline style and rewrites it when the
      // widget changes variant, so the band follows that rather than a guess.
      var height = (parseInt(widget.style.height, 10) || widget.offsetHeight || 102) + 'px';
      if (ul.style.getPropertyValue('--sc-clyde-h') !== height) {
        ul.style.setProperty('--sc-clyde-h', height);
        spacer.style.setProperty('--sc-clyde-h', height);
      }
      if (ul.className.indexOf('sc-has-clyde') === -1) {
        ul.className = (ul.className + ' sc-has-clyde').replace(/^ /, '');
      }
    }
  }

  sync();
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function() {
      if (queued) { return; }
      queued = true;
      window.setTimeout(function() { queued = false; sync(); }, 50);
    }).observe(row, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
  }
});

/***** Cart page: say that a Bold option edit is being saved *****
  Saving an option edit takes about three seconds before anything visibly happens.
  Bold does it as three sequential cart writes - change.js, update.js, add.js, roughly
  700ms each - and then reloads the cart page. None of that is ours to shorten, and
  the only feedback is Bold setting `disabled` on its own button while the label still
  reads "Update", which looks like nothing happened.

  So the click gets a spinner and a line saying what is going on. It is purely visual:
  the click is not intercepted, nothing is prevented, and the state goes away with the
  page reload Bold triggers at the end. If that reload never comes - a validation
  failure, say - it clears itself after twenty seconds rather than spinning forever.
***/
$(document).ready(function() {
  var table = document.querySelector('#your-shopping-cart #content .cart_tbl');
  if (!table) { return; }

  function clear(form) {
    form.className = form.className.replace(/ ?sc-bold-saving/, '');
    var note = form.querySelector('.sc-bold-saving__note');
    if (note) { note.parentNode.removeChild(note); }
  }

  table.addEventListener('click', function(e) {
    var node = e.target.nodeType === 1 ? e.target : e.target.parentElement;
    var button = node && node.closest && node.closest('button');
    if (!button || !/update/i.test(button.textContent || '')) { return; }
    var form = button.closest('.bold_options_edit_in_cart, .bold_option_edit_container');
    if (!form || form.className.indexOf('sc-bold-saving') > -1) { return; }

    form.className = (form.className + ' sc-bold-saving').replace(/^ /, '');
    var note = document.createElement('p');
    note.className = 'sc-bold-saving__note';
    note.setAttribute('role', 'status');
    note.innerHTML = '<span class="sc-bold-saving__spinner" aria-hidden="true"></span>' +
      'Saving your options\u2026 this takes a few seconds.';
    // After the last button in the group, not straight after Update - Bold puts
    // Cancel below it, and the note was landing between the two.
    var group = button.parentNode;
    var buttons = group.querySelectorAll('button');
    var last = buttons.length ? buttons[buttons.length - 1] : button;
    group.insertBefore(note, last.nextSibling);

    // Bold reloads the page when it is done; this is only for when it does not.
    window.setTimeout(function() { clear(form); }, 20000);
  });
});

/***** Product page: Add to Cart feedback, and Bold's required-option refusal *****
  Two jobs, and they are the same click.

  When the add is real, nothing on screen changes between the click and the cart page
  and the wait is long. Measured against the live theme: a plain product spends about
  680ms inside POST /cart/add before the browser so much as starts fetching /cart, and
  the cart rows paint at about 1.2s. A product with Bold options is worse - Bold reads
  the cart (~360ms), ajax-adds the hidden option line item (~590ms) and only then lets
  the native form POST go (~700ms), so the rows paint at about 2.6s. For the whole of
  that the button kept the same label on the same page, which reads as a click that
  missed and invites a second one. So a real add relabels the button and sweeps it.

  When a required Bold option is blank, Bold refuses the add and we stay on the page.
  Relabelling the button there is a lie, and it was worse than cosmetic: see below.

  Nothing is intercepted - no preventDefault, no stopPropagation, no rebinding - so the
  plain form submit and Bold's own handler behave exactly as before.
***/
$(document).ready(function() {
  var form = document.getElementById('addToCartForm');
  if (!form) { return; }

  var busy = null;
  var busyErrors = [];
  var timers = [];
  var suppressScrollUntil = 0;

  function liveButton() {
    // Bold hides the theme's #addToCart and injects a clone carrying the same id, so
    // there are usually two. The laid-out one is the one the shopper can see.
    var nodes = document.querySelectorAll('#addToCart');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getBoundingClientRect().width > 10) { return nodes[i]; }
    }
    return nodes[0] || null;
  }

  function visibleErrors() {
    var nodes = form.querySelectorAll('.bold_error_message, .bold_option_error');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getBoundingClientRect().height > 0) { out.push(nodes[i]); }
    }
    return out;
  }

  /* Which required options are still blank.

     Bold marks a required option with a trailing asterisk on its title span, and only
     there: the control itself carries no required, aria-required or data-required
     attribute (checked on the Jen-Ken AF3C, whose Controller is required - the select
     has none of them). window.BOLD exposes no validator either. So the asterisk Bold
     does render is the marker, read together with whether the control is still blank.

     Asking the DOM directly, instead of watching for Bold's error to appear, is what
     makes this answer per-click: it is the same on the first refused click and the
     fifth, and it comes back synchronously, before Bold has validated anything. Both
     of those matter - see the busy state and the stuck button below. Under-detection
     is the safe direction: an option whose required-ness is expressed some other way
     just falls through to the old behaviour. */
  function missingRequired() {
    var out = [];
    var opts = form.querySelectorAll('.bold_option');
    for (var i = 0; i < opts.length; i++) {
      var title = opts[i].querySelector('.bold_option_title');
      if (!title || !/\*\s*$/.test((title.textContent || '').replace(/^\s+|\s+$/g, ''))) { continue; }
      var ctl = opts[i].querySelector('select, textarea, input[type="text"], input[type="number"], input[type="email"], input[type="tel"]');
      if (!ctl || String(ctl.value).replace(/^\s+|\s+$/g, '') !== '') { continue; }
      out.push({ control: ctl });
    }
    return out;
  }

  /***** The explicit message *****/

  function clearNote() {
    var note = form.querySelector('.sc-atc-required');
    if (note) { note.parentNode.removeChild(note); }
  }

  function showNote(missing) {
    // Deliberately does not name the option. Bold already marks the offending control
    // itself - a red title, a red "This option is required." under it, and this branch
    // moves focus there - so naming it here only repeats what is already on screen a
    // few lines up. What the shopper is missing at the button is why the click did
    // nothing, and that is all this says. Singular when exactly one is unanswered,
    // which on these kilns is the usual case.
    var text = 'Please select the required ' +
      (missing.length === 1 ? 'option' : 'options') + ' to add this to your cart.';
    var note = form.querySelector('.sc-atc-required');
    if (note) {
      // Repeat click on the same unanswered option: leave the one note where it is
      // rather than stacking another, but re-announce it if the wording changed.
      if (note.textContent !== text) { note.textContent = text; }
      return;
    }
    note = document.createElement('p');
    note.className = 'sc-atc-required';
    note.setAttribute('role', 'alert');
    note.textContent = text;
    // At the top of the row holding the button that was just pressed. The shopper
    // clicked it, so it was on screen by definition - which is why this message needs
    // no scrolling to be seen, and why the page can usually stay exactly where it is.
    //
    // The row rather than the button: .price floats left and #addToCart floats right
    // in that one clearfix row, so a block inserted between them keeps the full-width
    // background but has its line boxes shortened by the price float - the text starts
    // hard against $1,461.60 and wraps under it. Going in as the row's first child
    // puts the message on a line of its own and leaves the price/button line alone.
    var button = liveButton();
    var row = button && button.closest ? button.closest('.desc_blk_bot') : null;
    if (row) {
      row.insertBefore(note, row.firstChild);
    } else if (button && button.parentNode) {
      button.parentNode.insertBefore(note, button);
    } else {
      form.appendChild(note);
    }
  }

  /***** Where the page should end up *****/

  /* The owner's rule: scroll up if anything; if the whole Customize Order box is
     already showing, do nothing; never overshoot.

     So this is a reveal, not a scroll-to. It only ever moves the page up, and only
     when the top of the box - where the options and Bold's error are - is hidden
     under the sticky header. A box that runs off the bottom of the viewport is left
     alone: its options are visible, and pulling the rest into view would mean
     scrolling down, which rule one forbids. */
  function revealBuyBox() {
    var box = form.querySelector('.desc_blk') || (form.closest ? form.closest('.desc_blk') : null);
    if (!box) { return; }
    var rect = box.getBoundingClientRect();
    var clear = scHeaderOffset();
    if (rect.top >= clear && rect.bottom <= window.innerHeight) { return; }
    var want = window.pageYOffset + rect.top - clear;
    // Never down, never past the top of the document.
    want = Math.max(0, Math.min(window.pageYOffset, want));
    if (Math.abs(want - window.pageYOffset) < 2) { return; }
    window.scrollTo({ top: want, behavior: 'smooth' });
  }

  /***** The busy state *****/

  function clearBusy() {
    if (!busy) { return; }
    busy.className = busy.className.replace(/ ?sc-atc-busy/, '');
    busy.removeAttribute('aria-busy');
    if (busy.getAttribute('data-sc-label') !== null) {
      busy.value = busy.getAttribute('data-sc-label');
      busy.removeAttribute('data-sc-label');
    }
    busy = null;
    busyErrors = [];
    while (timers.length) { window.clearTimeout(timers.pop()); }
  }

  function startBusy(button) {
    if (busy) { return; }
    busy = button;
    busyErrors = visibleErrors();
    button.setAttribute('data-sc-label', button.value);
    button.value = 'Adding to Cart…';
    button.setAttribute('aria-busy', 'true');
    button.className = (button.className + ' sc-atc-busy').replace(/^ /, '');

    /* The busy state carries pointer-events:none, so one that never clears is a dead
       Add to Cart button. It used to stick for the full 15s backstop: the old test was
       whether the number of visible Bold errors had RISEN since the click, and on a
       second refused click the error was already on screen, so the count never rose.
       Bold also leaves its error node in the DOM verbatim after the option has been
       corrected, so the count was still 1 on every later click - fixing the option did
       not revive the button either.

       A required option blank at click time no longer gets here at all, which is the
       real fix. What is left is three independent ways out, none of which can wait on
       a count: an error node that was not already on screen appearing (compared by
       node, not by tally, so a re-shown node still counts as new), any edit inside the
       form, and a backstop at 6s - a little over twice the 2.6s a Bold add takes. */
    for (var i = 1; i <= 24; i++) {
      timers.push(window.setTimeout(function() {
        var now = visibleErrors();
        for (var j = 0; j < now.length; j++) {
          if (busyErrors.indexOf(now[j]) === -1) { clearBusy(); return; }
        }
      }, i * 250));
    }
    timers.push(window.setTimeout(clearBusy, 6000));
  }

  /***** Bold's own scroll *****/

  /* Bold reveals the offending option by calling scrollIntoView() on its label
     (options.js), which lands the label at the very top of the viewport - i.e. under
     the fixed header, so the error sits just above the fold. Measured on the Jen-Ken
     AF3C at 1400x900: the Customize Order box was already fully on screen (top 318,
     bottom 770 of a 900px viewport) and Bold scrolled the page DOWN 387px, leaving the
     box at top -153 and the error message at top -8, behind an 84px fixed header.

     Bold is not ours to edit, and letting its smooth scroll run and then scrolling
     back would show the shopper a 387px dive and a snap. It calls scrollIntoView
     synchronously inside the click, so the call is dropped instead, and we do our own
     reveal. Scoped to nodes inside the product form and to a 400ms window after a
     refused click, so nothing else on the page is affected. */
  var nativeScrollIntoView = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function() {
    if (Date.now() < suppressScrollUntil && form.contains(this)) { return; }
    return nativeScrollIntoView.apply(this, arguments);
  };

  /***** The click *****/

  // Capture phase on the form: Bold binds its handler to whichever button is live, so
  // running first means we see the click whichever one was pressed, and can tell a
  // refused add from a real one before Bold has touched anything.
  form.addEventListener('click', function(e) {
    var node = e.target.nodeType === 1 ? e.target : e.target.parentElement;
    var button = node && node.closest && node.closest('#addToCart');
    if (!button) { return; }

    var missing = missingRequired();
    if (!missing.length) {
      clearNote();
      startBusy(button);
      return;
    }

    // Refused. No busy state - the add is not happening and saying otherwise is the
    // bug. Bold will render its own per-option error; we add a plain one at the button
    // and keep the page still enough to read both.
    suppressScrollUntil = Date.now() + 400;
    showNote(missing);
    try {
      // preventScroll, or focusing the select would itself scroll it into view and
      // undo the rule above.
      missing[0].control.focus({ preventScroll: true });
    } catch (err) { /* older browsers: skip the focus rather than take the scroll */ }
    // After a frame, so the note we just inserted is in the layout being measured.
    window.requestAnimationFrame(function() { revealBuyBox(); });
  }, true);

  // Editing anything in the form means the shopper is still choosing, so the add
  // plainly did not happen: drop a stuck busy state, and drop the message once there
  // is nothing left to choose.
  function onEdit() {
    clearBusy();
    if (!missingRequired().length) { clearNote(); }
  }
  form.addEventListener('change', onEdit, true);
  form.addEventListener('input', onEdit, true);

  // A back-button restore would otherwise hand the shopper a cached page frozen mid-add.
  window.addEventListener('pageshow', function(e) { if (e.persisted) { clearBusy(); clearNote(); } });
});

/***** Review stars in the buy box -> scroll to the Reviews block (header-aware) ***/
$(document).ready(function() {
  var reviews = document.querySelector('.sc-reviews');
  if (!reviews) { return; }
  // Capture phase on document runs before Judge.me's own click handler, so we can
  // replace its scroll (which ignores the sticky header and overshoots the heading).
  document.addEventListener('click', function(e) {
    var badge = e.target.closest && e.target.closest('.review_row .jdgm-prev-badge');
    if (!badge) { return; }
    e.preventDefault();
    e.stopPropagation();
    scScrollToElement(reviews);
  }, true);
});

/***** In-page anchors (e.g. warranty page brand links, product tab -> #brand): land below
       the sticky header instead of under it. Covers hash on load and anchor clicks. ***/
$(document).ready(function() {
  function targetFor(hash) {
    if (!hash || hash.length < 2) { return null; }
    try { return document.getElementById(decodeURIComponent(hash.slice(1))); } catch (e) { return null; }
  }
  var initial = targetFor(window.location.hash);
  if (initial) {
    // Let the browser's own jump (and any layout settling) happen first, then re-aim.
    setTimeout(function() { scScrollToElement(initial); }, 150);
  }
  document.addEventListener('click', function(e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) { return; }
    // Leave Bootstrap tabs/collapses and other JS toggles alone.
    if (a.hasAttribute('data-toggle') || a.closest('.nav-tabs')) { return; }
    var el = targetFor(a.getAttribute('href'));
    if (el && el.classList.contains('tab-pane')) { return; }
    if (!el) { return; }
    e.preventDefault();
    scScrollToElement(el);
    if (window.history && window.history.replaceState) { window.history.replaceState(null, '', a.getAttribute('href')); }
  });
});

/***** Promise card placement on tablet / small-desktop widths: put it in whichever
       column (gallery or buy box) has the shorter content, so it fills the gap. ***/
$(document).ready(function() {
  var card = document.querySelector('.sc-promise--column');
  var cols = document.querySelectorAll('.pro_main_c > .row > .col-sm-6');
  if (!card || cols.length < 2) { return; }
  var mq = window.matchMedia('(min-width: 768px)');
  // A column card is only worth using where it has room for its badges. Below 1200px
  // the buy box is col-md-5 (41.67%) rather than col-lg-6, so the card is 345-374px
  // wide and its 2-up badge grid gets ~169-184px per badge, which wraps the labels
  // onto two lines: 3 of 4 on the Jen-Ken AF3C, 2 of 3 on the Speedball Clay Boss,
  // at every width from 768 to 1199. At 1200 the card jumps to 555px (274px a badge)
  // and nothing wraps. The boundary is exactly Bootstrap's lg breakpoint, which is
  // also where the stylesheet already bumps this card's label from 13px to 14px and
  // its icon from 44px to 50px - the roomy card was only ever designed for >=1200.
  // So below that, use the full-width strip regardless of the gap between columns.
  var roomy = window.matchMedia('(min-width: 1200px)');

  // Painted extent of the column's own content (ignoring the card): the lowest bottom
  // edge of any visible descendant, so wrappers, collapsed margins and flex stretch
  // cannot skew the comparison.
  function contentHeight(col) {
    var top = col.getBoundingClientRect().top;
    var bottom = top;
    Array.prototype.forEach.call(col.querySelectorAll('*'), function(el) {
      if (card.contains(el) || el === card) { return; }
      var r = el.getBoundingClientRect();
      if (r.height === 0 && r.width === 0) { return; }
      if (r.bottom > bottom) { bottom = r.bottom; }
    });
    return bottom - top;
  }

  // When the columns are already close in height, a card under either one just
  // overshoots the other; use the full-width strip instead.
  // Card variants, tallest first. The script picks the tallest one whose natural height
  // (incl. bottom margin) fits the gap, allowing a small overshoot; the chosen card then
  // stretches to fill the gap exactly.
  var VARIANTS = ['', 'sc-promise--medium', 'sc-promise--compact'];
  function setVariant(cls) {
    VARIANTS.forEach(function(v) { if (v) { card.classList.toggle(v, v === cls); } });
  }
  function naturalHeight(cls) {
    var current = VARIANTS.filter(function(v) { return v && card.classList.contains(v); })[0] || '';
    var prevFlex = card.style.flex, prevDisplay = card.style.display;
    setVariant(cls);
    card.style.flex = 'none';
    card.style.display = 'flex';
    var h = card.offsetHeight + parseFloat(window.getComputedStyle(card).marginBottom || 0);
    card.style.flex = prevFlex;
    card.style.display = prevDisplay;
    setVariant(current);
    return h;
  }

  // Below NEAR_EQUAL the full-width strip is used instead of any card.
  var NEAR_EQUAL = 70, OVERSHOOT = 45, SLACK_MAX = 60;
  // The column heights place() last decided on. Only a change here should hold the
  // reveal back; a re-place that measures the same columns is not the page moving.
  var measured = '';
  var revealed = false, settleTimer = null;

  // Once the card is revealed its position is final until the viewport itself
  // changes. Everything after the reveal - Bold at ~3.6s, Clyde at ~4-6s - would
  // otherwise re-open the decision and move a card the visitor is already looking
  // at. See the note below the function for why that trade changed.
  function place(relayout) {
    // The stacked layout is checked before the freeze: crossing below 768px changes
    // layout mode outright, and leaving a card stranded in the buy-box column with
    // a stale inline flex would be wrong however the call got here.
    if (!mq.matches) {
      document.body.classList.remove('sc-promise-wide');
      setVariant('');
      // clear any inline flex left over from a wider viewport
      card.style.flex = '';
      if (card.parentNode !== cols[0]) { cols[0].appendChild(card); }
      measured = 'stacked';
      return;
    }
    // Too narrow for a column card: full-width strip, whatever the gap. Checked with
    // the stacked case and ahead of the freeze for the same reason - it is a layout
    // mode keyed on the viewport, not a decision about the columns - and it costs no
    // measuring, so a frozen card re-asserting it on an idle tick is free.
    if (!roomy.matches) {
      document.body.classList.add('sc-promise-wide');
      setVariant('');
      card.style.flex = '';
      measured = 'narrow';
      return;
    }
    if (revealed && !relayout) { return; }
    var h0 = contentHeight(cols[0]), h1 = contentHeight(cols[1]);
    measured = h0 + 'x' + h1;
    var gap = Math.abs(h0 - h1);
    if (gap < NEAR_EQUAL) {
      document.body.classList.add('sc-promise-wide');
      return;
    }
    document.body.classList.remove('sc-promise-wide');
    var target = h0 <= h1 ? cols[0] : cols[1];
    if (card.parentNode !== target) { target.appendChild(card); }
    var chosen = VARIANTS[VARIANTS.length - 1];
    for (var i = 0; i < VARIANTS.length; i++) {
      if (gap >= naturalHeight(VARIANTS[i]) - OVERSHOOT) { chosen = VARIANTS[i]; break; }
    }
    setVariant(chosen);

    // Stretching only makes sense while the gap is close to the card's own height.
    // On a product with a very short buy box - no variants, no Bold options, no
    // protection widget - the gap runs far past even the tallest variant, and the
    // card ballooned to fill it: 415px of card around 216px of badges on the Durston
    // wedging table, ~100px of empty white above and below. Past SLACK_MAX the card
    // keeps its natural height and the leftover is page background instead.
    card.style.flex = gap - naturalHeight(chosen) > SLACK_MAX ? 'none' : '';
  }

  // ----- place while hidden, reveal once the columns go quiet ------------------
  // The visible jump is the initial cascade: the card lands in one column off the
  // first measurement, then the gallery finishes loading and it moves to the other.
  // So place freely while the card is out of the flow and only reveal once neither
  // column has changed for SETTLE_MS.
  //
  // The card is decided once and then left alone. An earlier revision kept the
  // observer live after the reveal so late third-party growth could be corrected,
  // on the grounds that the card gets dragged down anyway and correcting it at
  // least keeps the columns level. That was measured against Bold alone, where the
  // difference was noise (0.0265 frozen vs 0.0293 live). Clyde makes the trade a
  // clear loss, because it does not merely drag the card - it re-opens the
  // decision:
  //
  //   #clyde-id ships on every product page at 15px tall and Clyde fills it in
  //   later, so the buy-box column grows +52px at 1400/1852px, +68px at 991px,
  //   measured on the Jen-Ken AF3C, arriving at ~4-6s - long after the reveal.
  //   NEAR_EQUAL is 70, so a change that size can flip which column is shorter,
  //   cross a card-variant boundary, or drop the gap under NEAR_EQUAL and swap the
  //   column card for the full-width strip. Those are column hops and resizes, not
  //   a 52px nudge, and they land seconds after the visitor is reading the page.
  //
  // Freezing cannot stop Clyde pushing the card down when the card sits below it -
  // nothing in the theme can, short of reserving space, and that is not available
  // (see the report: Clyde populates only 28% of products and its height depends on
  // viewport width, so a blanket reservation would carve dead whitespace on the
  // other 72%). What freezing does remove is the far larger motion the theme itself
  // was adding on top. The cost is that the columns can end up out of level by
  // roughly Clyde's height; that is cosmetic slack of the same kind SLACK_MAX
  // already tolerates, and motion is what was actually complained about.
  //
  // A genuine viewport resize still re-decides everything, via place(true).
  var SETTLE_MS = 400;
  function reveal() {
    if (revealed) { return; }
    revealed = true;
    clearTimeout(settleTimer);
    document.documentElement.classList.remove('sc-promise-deciding');
  }
  function armSettle() {
    if (revealed) { return; }
    clearTimeout(settleTimer);
    settleTimer = setTimeout(function () { place(); reveal(); }, SETTLE_MS);
  }

  var timer = null;
  // A re-place that found the columns unchanged does not restart the settle window.
  // Without that test the load handler re-armed it unconditionally, so the reveal
  // could never happen before load + ~520ms even on a page that had stopped moving
  // long before. Measured on the Durston table, reveal went from a steady load+550ms
  // to load+100ms; on the Jen-Ken and the Speedball it now usually precedes load.
  // Absolute times are too network-dependent here to quote - see the branch report.
  // A requested relayout is sticky across the debounce. Resizing the viewport also
  // resizes the columns, so the ResizeObserver fires immediately afterwards and its
  // clearTimeout would otherwise cancel the pending relayout and replace it with an
  // ordinary tick - which a revealed card ignores. That race silently swallowed
  // every resize: dropping from 1400px to 390px left the card in the buy-box column
  // with flex:0 0 auto still set, instead of stacked back under the gallery.
  var pendingRelayout = false;
  function schedule(relayout) {
    if (relayout) { pendingRelayout = true; }
    clearTimeout(timer);
    timer = setTimeout(function () {
      var rl = pendingRelayout;
      pendingRelayout = false;
      var before = measured;
      place(rl);
      if (measured !== before) { armSettle(); }
    }, 120);
  }
  place();
  armSettle();
  // Wrapped, not passed by reference: every one of these callbacks is handed an
  // argument (an Event, or the observer's entries array) that would otherwise be
  // read as a truthy relayout and re-open a decision that is meant to be final.
  window.addEventListener('load', function () { schedule(); });
  // A viewport change is the one event that may re-decide a revealed card: the
  // breakpoints and the gap it was sized to have both moved. Pass relayout through
  // explicitly - schedule is also the ResizeObserver callback, which receives an
  // array of entries as its first argument and must not be read as a flag.
  window.addEventListener('resize', function () { schedule(true); });
  // Bold options, the gallery and Judge.me all change the columns after load; re-place
  // whenever either column's size changes (decisions ignore the card, so this settles).
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(function () { schedule(); });
    ro.observe(cols[0]);
    ro.observe(cols[1]);
    Array.prototype.forEach.call(cols[1].children, function(c) { ro.observe(c); });
  } else {
    // No observer to go quiet, so fall back to fixed re-places and a fixed reveal.
    // Nothing after the reveal: a revealed card is final here too, so the 4s and 8s
    // re-places this used to carry would be no-ops.
    setTimeout(function () { schedule(); }, 1500);
    setTimeout(reveal, 2500);
  }
});
